import React from 'react';
import { ChevronRight, FileSpreadsheet, Table2, BarChart3, Download } from 'lucide-react';
import useI18n from '../hooks/useI18n';

const sectionIcons = {
  overview: Table2,
  dashboard: BarChart3,
  export: Download,
};

const Breadcrumb = ({ filename, activeSheet, activeSection, onNavigate }) => {
  const { t } = useI18n();
  if (!filename) return null;

  const SectionIcon = sectionIcons[activeSection] || Table2;
  const sectionLabel = t(`nav.${activeSection}`) || activeSection;

  return (
    <nav aria-label="breadcrumb" className="flex items-center gap-1 text-xs text-muted-foreground py-2 overflow-x-auto" data-testid="breadcrumb">
      <button
        onClick={() => onNavigate('overview')}
        className="flex items-center gap-1 hover:text-foreground transition-colors shrink-0 btn-press"
      >
        <FileSpreadsheet className="w-3 h-3" />
        <span className="font-medium truncate max-w-[120px]">{filename}</span>
      </button>

      <ChevronRight className="w-3 h-3 shrink-0 opacity-40" />

      <span className="font-mono truncate max-w-[100px]">{activeSheet}</span>

      <ChevronRight className="w-3 h-3 shrink-0 opacity-40" />

      <span className="flex items-center gap-1 text-foreground font-medium shrink-0">
        <SectionIcon className="w-3 h-3" />
        {sectionLabel}
      </span>
    </nav>
  );
};

export default Breadcrumb;
